<template>
  <div class="holidayIndex">
    <Header title="" type="0" route="/homeIndex"></Header>
  
    <div  class="content">
      <div class="item-top">
          <van-row>
            <van-col span="24">
              <ul>
                <h2>{{ bt }}</h2>
                <p v-html="nr"></p>
              </ul>
            </van-col>
          </van-row>
        </div>
    </div>
    <div class="bottom-btn">
      <button @click="onclick">我已阅读</button>
    </div>
  </div>
</template>
<script>
import { Api } from "@/utils/axios";

export default {
  data() {
    return {
      bt: '',
      nr:'',
      xn:''
    };
  },
  methods: {
    async getdkxz() {
      const res = await Api.getZyjhDkxz_JS();
      if("fail" === res.errorCode){
        alert(res.errorMessage)
        this.$router.push("/homeIndex");
      }else{
        const data = res.data;
        this.bt = data.bt;
        this.nr = data.context;
        this.xn = data.xn;
      }
    },
    onclick(item, flag) {
      this.$router.push({
        path:'/teacher/zyjhDk',
        query: {
          xn: this.xn,
        }
      })
    }
  },
  created() {
    this.getdkxz();
  }
};
</script>
<style lang="less">
.holidayIndex {
  .content {
    height: calc(~"100vh - 110px");
    overflow: auto;
    padding: 0 5% 0;
    .list-item {
      background: #f8f8f8;
      border-radius: 5px;
      margin: 0 auto 5%;
      position: relative;
      .item-top {
        padding: 3% 0 3% 6%;
        p {
          font-family: PingFangSC-Medium;
          font-size: 16px;
          color: #212f6e;
          letter-spacing: 0;
          font-weight: bolder;
          line-height: 42px;
        }
        ul li {
          font-family: PingFangSC-Light;
          font-size: 12px;
          color: #757da3;
          letter-spacing: 0;
          margin-bottom: 1%;
        }
        span {
          width: 70px;
          height: 42px;
          border-radius: 5px;
          position: absolute;
          top: calc(50% - 30px);
          right: 5%;
          display: inline-flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          font-family: PingFangSC-Light;
          font-size: 16px;
          letter-spacing: 0;
          line-height: 15px;
        }
        .shzClass {
          color: #7469f8;
        }
        .btgClass {
          color: #f86969;
        }
        .ytgClass {
          color: #12ddd6;
        }
        .dssClass {
          color: #757da3;
        }
      }
      .operate {
        border-top: 1px solid #dee1e9;
        display: block;
        height: 40px;
        line-height: 40px;
        display: flex;
        width: 100%;
        background-color: #ecedfd;
        box-sizing: border-box;
        border-radius: 0 0 5px 5px;
        span {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #212f6e;
          letter-spacing: 0;
          text-align: center;
          flex: 1;
          cursor: pointer;
          &:last-child {
            border-left: 1px solid #dee1e9;
          }
          &:nth-child(2) {
            border-left: 1px solid #dee1e9;
          }
        }
        .disClass {
          color: gray;
          background-color: #f8f8f8;
        }
      }
    }
  }
  .bottom-btn {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 60px;
    padding-bottom: 10px;
    padding: 0 5%;
    background: #fff;
    box-sizing: border-box;

    button {
      width: 100%;
      height: 44px;
      background: #7469f8;
      border-radius: 3px;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/teacher/zyjh/zyjhDkxz.vue